import AddButton from "./AddButton";
import SideBarBatch from "./SideBarBatch";
import SideBarElem from "./SideBarElem";
import { FaUsers } from "react-icons/fa";
import { useState } from "react";
import SearchBar from "../SearchBar";
import { useElemContext } from "../../Contexts/ElemContext";

export default function MobileSideBar({
  pathname,
  filteredGroups,
  filteredExaminers,
}) {
  const { search, setSearch } = useElemContext();
  const [menuOpen, setMenuOpen] = useState(false);
  return (
    <>
      {menuOpen && (
        <div
          className="fixed inset-0 bg-black bg-opacity-50 z-40"
          onClick={() => setMenuOpen(false)}
        />
      )}
      <button
        className="fixed top-5 left-5 text-white p-2 rounded-2xl border-white border-2 z-20"
        onClick={() => setMenuOpen(!menuOpen)}
      >
        <FaUsers size={25} />
      </button>
      <div
        className={`fixed top-0 left-0 h-full z-50 w-[50vw] bg-primary-yellow border transform transition-transform duration-300 overflow-y-scroll
      ${
        menuOpen
          ? "translate-x-0 opacity-100 pointer-events-auto"
          : "-translate-x-full opacity-0 pointer-events-none"
      }`}
      >
        <div className="flex border-2 border-black p-1 fixed bg-primary-yellow w-full">
          <SearchBar search={search} setSearch={setSearch} />
          <AddButton pathname={pathname} />
        </div>

        <div className="relative top-[4rem]">
          {pathname === "/student" &&
            filteredGroups.map((g) => (
              <SideBarBatch key={g.id} content={g.name} list={g.students} />
            ))}

          {pathname === "/examiner" &&
            filteredExaminers.map((ex) => (
              <SideBarElem key={ex.id} content={ex} contentType="examiner" />
            ))}
        </div>
      </div>
    </>
  );
}
